import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form/components/base-ctrl-value-accessor-form.component';

import { SGT } from '@atmi/core/models';

@Component({
  selector: 'app-sgt-form',
  templateUrl: './sgt-form.component.html',
  styleUrls: ['./sgt-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SgtFormComponent extends BaseCtrlValueAccessorFormComponent<SGT> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
